import { useState } from "react";

import Controls from "../components/3d/controls";
import TerrainLoader from "../utils/terrain-loader";

import AutoHeightEmbed from "../components/auto-height-embed";

import Sections3D from "../components/sections-3d";

import log from "loglevel";

const Sections = (props) => {
  const dt = new Date();
  const tm = dt.getHours() + dt.getMinutes() / 60;
  const perc = Math.clamp((tm - 6) / 12);
  const [controlData, updateControlData] = useState({
    time: Math.clamp((9 - 6) / 12), //9 Am,
    date: dt.getDOY() / 366,
  });

  return (
    <>
      <Controls controlData={controlData} onChange={updateControlData} />
      <AutoHeightEmbed className="card">
        <TerrainLoader>
          <Sections3D controlData={controlData} />
        </TerrainLoader>
      </AutoHeightEmbed>
    </>
  );
};

export default Sections;
